import React, { useContext } from "react";
import {
    GelLabel,
    GelBoxLayout,
    GelContainerLite,
    GelIcon,
    GelScreenDetectorContext,
    GelParagraph
} from '@tal-gel/components';
import { getGelTokens } from '@tal-gel/theming';
import { AdobeClickType, CLAIM_STATUS_TYPE } from "../../constants/constants";
import Tag, { TagStatus } from "../../common/components/Tag";
import { AdobeAnalytics } from "../../common/analytics/adobe-analytics";
import { useCookies } from "react-cookie";
import { MMCTooltip } from "../../common/components/tooltip";

interface BenefitTypeProps {
    description: string;
    friendlyStatus: string;
    tooltipText: string;
    isFromHomePage?: boolean;
    claimNumber: string;
    benefitTypeText: string;
    showBenefitType?: boolean;
    isExpandable?: boolean;
    toggleBenefitExpandable?: () => void;
}

const BenefitType = (props: BenefitTypeProps) => {
    const { screen, isXsScreen } = useContext(GelScreenDetectorContext) as GelScreenDetectorContext;
    const { global: { sizeBaseX10, sizeBaseX6, sizeBaseHalf, themeColorIconDefault } } = getGelTokens();
    const { description, friendlyStatus, tooltipText, isFromHomePage, 
        claimNumber, benefitTypeText, showBenefitType, isExpandable,
        toggleBenefitExpandable } = props
    const [{ tpid }] = useCookies(['tpid']);

    const RenderTag = (): React.ReactNode => {
        let status = "";

        switch (true) {
            case [CLAIM_STATUS_TYPE.APPROVED, CLAIM_STATUS_TYPE.PAID, CLAIM_STATUS_TYPE.FSD].includes(description):
                status = TagStatus.SUCCESS;
                break;
            case description === CLAIM_STATUS_TYPE.BR:
                status = TagStatus.WARNING;
                break;
            case [CLAIM_STATUS_TYPE.CN, CLAIM_STATUS_TYPE.RFI].includes(description):
                status = TagStatus.DANGER;
                break;
            case description == CLAIM_STATUS_TYPE.CL || description.includes(CLAIM_STATUS_TYPE.RTS):
                status = TagStatus.NEUTRAL;
                break;
            case [CLAIM_STATUS_TYPE.PENDING, CLAIM_STATUS_TYPE.ST].includes(description):
                status = TagStatus.INFO;
                break;
            default:
                break;
        }

        return <Tag text={friendlyStatus} status={status} />;
    }

    return (
        <GelContainerLite style={{
            padding: isFromHomePage ? "25px 16px" :
                `${sizeBaseX6}px ${sizeBaseX10}px`,

        }}>
            <GelBoxLayout space={!isXsScreen(screen) ? [7, 0.1, 0.03, 0.04] : [5, 0.01, 1, 0.05]} gutter={sizeBaseHalf}
                alignmentIndividual={['start', 'start', 'start', 'center']}
                style={{
                    marginRight: isFromHomePage ? '-14px' : '0px',
                    marginLeft: '0px',
                    marginBottom: '4px',
                    flexDirection: !isXsScreen(screen) ? "row" : "column",
                    alignItems: !isXsScreen(screen) ? "center" : "normal"
                }}
                childStyle={{
                    paddingLeft: '0px',
                    paddingRight: '0px',
                }}>

                <GelLabel style={{
                    display: "block",
                }}>{benefitTypeText}
                </GelLabel>

                {isXsScreen(screen) ? (<GelParagraph style={{ fontSize: 14, fontWeight: 400, margin: "4px 0" }}>
                    Claim number: {claimNumber}
                </GelParagraph>)
                    : null}
                <GelContainerLite style={{ padding: 0 }}>
                    <GelBoxLayout space={[0.5, 0.1]} distribution="start" alignment="stretch" gap="none">
                        <RenderTag />
                        <MMCTooltip selfAdaptive style={{ padding: isXsScreen(screen) ? "6px 4px 4px 0px" : "4px 4px 4px 0px" }}>
                            {AdobeAnalytics.PushClickEvent(tpid, tooltipText, AdobeClickType.Tooltip)}
                            {tooltipText}
                        </MMCTooltip>
                    </GelBoxLayout>
                </GelContainerLite>
                {isExpandable &&
                    <GelIcon name={showBenefitType ? "ChevronUp" : "ChevronDown"} color={themeColorIconDefault}
                        width="20px" height="20px" style={{ padding: 4 }}  onClick={toggleBenefitExpandable}/>}
                
            </GelBoxLayout>

            {!isXsScreen(screen) ?
                <GelParagraph style={{ fontSize: 14, fontWeight: 400 }}>Claim number: {claimNumber}</GelParagraph> : null}

        </GelContainerLite>
    );
}

export default BenefitType;